const TestimonialData = [
  {
    profilePic: "./TestimonialPP/deepanshi.png",
    message:
      "Chirag has developed a range of websites and he has good understanding of JavaScript, React and Node JS",
    name: "Deepanshi Gandherva",
  },
  {
    profilePic: "./TestimonialPP/ajay-kumar.png",
    message:
      "Chirag is a guy who has developed many useful tools on different platforms and has a lot of potential. He is a package who owns the knowledge of multiple technologies like JS, ReactJS, NodeJS and I'm sure if you're currently reading this, he must have added a few more in this list by now",
    name: "Ajay Kumar",
  },
  {
    profilePic: "./TestimonialPP/gaurav-sharma.jpeg",
    message:
      "neque nesciunt, nemo aliquam illo iste expedita dit accusamus, sed, obcaecati uga, magni laborum provident animi?",
    name: "Gaurav Sharma",
  },
  {
    profilePic: "./TestimonialPP/shishu pal yadav.png",
    message:
      "neque nesciunt, nemo aliquam illo iste expedita tenetur quia nulla. Illum magni consectetur fa reprehenderit! Et vitae, nobis, perferendis molestias autem repellat debitis ea enim nam numq nt. Quaerat corporis ullam ducimus fuga, magni laborum provident animi?",
    name: "SP Yadav",
  },
];

export default TestimonialData;
